import { render, staticRenderFns } from "./EditorMenuItem.vue?vue&type=template&id=2142e9c6&scoped=true&"
import script from "./EditorMenuItem.vue?vue&type=script&lang=js&"
export * from "./EditorMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./EditorMenuItem.vue?vue&type=style&index=0&id=2142e9c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142e9c6",
  null
  
)

export default component.exports